module.exports = __webpack_public_path__ + "static/media/lb-nome.bfb7490a.svg";